// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MetaBlock__container-c0bc39 {
  display: flex;
  box-sizing: border-box;
  position: relative;
  padding: 8px var(--meta-block-padding);
  /*DO NOT change naming*/
  --meta-block-actions-background: var(--base-0);
  --meta-block-padding: 16px;
}

.MetaBlock__small-1-size-ad759b {
  --meta-block-padding: 16px;
}

.MetaBlock__small-2-size-c3ca39 {
  --meta-block-padding: 24px;
}

.MetaBlock__icon-edb16a {
  fill: var(--base-80);
  margin-inline-end: 24px;
}

.MetaBlock__info-e44d39 {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  flex: 1;
}

.MetaBlock__label-ed4bc8 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}

.MetaBlock__content-f3de18 {
  overflow: hidden;
  color: var(--base-110);
}

.MetaBlock__shadow-e7c505 {
  background: linear-gradient(90deg, transparent 0%, var(--meta-block-actions-background) 100%);
  width: 33px;
  height: 56px;
}

.MetaBlock__actions-c047d3 {
  opacity: 0;
  transition: opacity 0.15s ease;
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
}

.MetaBlock__container-c0bc39:hover .MetaBlock__actions-c047d3 {
  opacity: 1;
  transition-duration: 0s;
}

.MetaBlock__actions-background-afdb51 {
  align-items: center;
  background-color: var(--meta-block-actions-background);
  display: flex;
}

.MetaBlock__actions-background-afdb51 > button {
  margin-inline-end: 14px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/MetaBlock/MetaBlock.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sCAAA;EAEA,uBAAA;EACA,8CAAA;EACA,0BAAA;AAAF;;AAGA;EACE,0BAAA;AAAF;;AAGA;EACE,0BAAA;AAAF;;AAGA;EACE,oBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,OAAA;AAAF;;AAGA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,6FAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,UAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;AAAF;;AAGA;EACE,UAAA;EACA,uBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,sDAAA;EACA,aAAA;AAAF;;AAGA;EACE,uBAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  box-sizing: border-box;\n  position: relative;\n  padding: 8px var(--meta-block-padding);\n\n  /*DO NOT change naming*/\n  --meta-block-actions-background: var(--base-0);\n  --meta-block-padding: 16px;\n}\n\n.small-1-size {\n  --meta-block-padding: 16px;\n}\n\n.small-2-size {\n  --meta-block-padding: 24px;\n}\n\n.icon {\n  fill: var(--base-80);\n  margin-inline-end: 24px;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n  flex: 1;\n}\n\n.label {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n\n.content {\n  overflow: hidden;\n  color: var(--base-110);\n}\n\n.shadow {\n  background: linear-gradient(90deg, transparent 0%, var(--meta-block-actions-background) 100%);\n  width: 33px;\n  height: 56px;\n}\n\n.actions {\n  opacity: 0;\n  transition: opacity 0.15s ease;\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.container:hover .actions {\n  opacity: 1;\n  transition-duration: 0s;\n}\n\n.actions-background {\n  align-items: center;\n  background-color: var(--meta-block-actions-background);\n  display: flex;\n}\n\n.actions-background > button {\n  margin-inline-end: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MetaBlock__container-c0bc39`,
	"small-1-size": `MetaBlock__small-1-size-ad759b`,
	"small1Size": `MetaBlock__small-1-size-ad759b`,
	"small-2-size": `MetaBlock__small-2-size-c3ca39`,
	"small2Size": `MetaBlock__small-2-size-c3ca39`,
	"icon": `MetaBlock__icon-edb16a`,
	"info": `MetaBlock__info-e44d39`,
	"label": `MetaBlock__label-ed4bc8`,
	"content": `MetaBlock__content-f3de18`,
	"shadow": `MetaBlock__shadow-e7c505`,
	"actions": `MetaBlock__actions-c047d3`,
	"actions-background": `MetaBlock__actions-background-afdb51`,
	"actionsBackground": `MetaBlock__actions-background-afdb51`
};
module.exports = ___CSS_LOADER_EXPORT___;
